import { TicketJobType } from "_enums/enums";

// A ticket's job type (Ticket.jobType). Tickets from before the field existed
// have none until the server backfill runs: a compliance task is still known by
// its record link, and anything else was a repair job. Mirrors jobTypeOf in
// fixify-server/service/lib/jobType.js.
export const jobTypeOf = (ticket) =>
  ticket?.jobType || (ticket?.complianceId ? TicketJobType.Compliance : TicketJobType.Repair);

export const isComplianceJob = (ticket) => jobTypeOf(ticket) === TicketJobType.Compliance;

// My Jobs pillars (docs/features/my-jobs-filtering.md): Maintenance is hidden
// until it is defined, and there is no view across pillars.
export const MY_JOBS_PILLARS = [TicketJobType.Repair, TicketJobType.Compliance];

/** The selected My Jobs pillar; Repairs when none is set (sidebar, dashboard, first visit). */
export const pillarOf = (filters) => (MY_JOBS_PILLARS.includes(filters?.jobType) ? filters.jobType : TicketJobType.Repair);
